import React from 'react';
import { connect } from 'react-redux';
import Form from '../../FormsTemplate';
import { FormNames } from '../../Forms.constants';

import UserInfoSection from '../../Sections/UserInfoSection/UserInfoSection';
import ManufacturerModelSection from '../../Sections/ManufacturerModelSection/ManufacturerModelSection';
import DeviceTypesSection from '../../Sections/DeviceTypesSection/DeviceTypesSection';
import HMISection from '../../Sections/HMISection/HMISection';
import VisualInspectSection from '../../Sections/VisualInspectSection/VisualInspectSection';
import HighLowCurrentSection from '../../Sections/HighLowCurrentSection/HighLowCurrentSection';
import TestResultSection from '../../Sections/TestResultSection/TestResultSection';
import AsLeftTestTableSection from '../../Sections/AsLeftTestTableSection/AsLeftTestTableSection';
import AsFoundTestTableSection from '../../Sections/AsFoundTestTableSection/AsFoundTestTableSection';
import NoteSection from '../../Sections/NoteSection/NoteSection';
import ToleranceInstrumentEUCommentSection from '../../Sections/ToleranceInstrumentEUComment/ToleranceInstrumentEUComment';
import BorderedBox from '../../BorderedBox';
import TestResultComponent from '../../Sections/TestResultComponent/TestResultComponent';

const P71Form = (props) => (
    <Form
        formName={FormNames.P71}
    >
        <UserInfoSection />
        <ManufacturerModelSection />
        <DeviceTypesSection />
        <HMISection />
        <VisualInspectSection />
        <HighLowCurrentSection />
        <BorderedBox>
            <AsFoundTestTableSection />
        </BorderedBox>
        <ToleranceInstrumentEUCommentSection />
        <BorderedBox>
            <AsLeftTestTableSection />
        </BorderedBox>
        <TestResultSection />
        <TestResultComponent />
        <NoteSection />
    </Form>
);

const mapStateToProps = ({ Forms }) => ({
    selectedTag: Forms.selectedTag,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(P71Form);
